import { render, staticRenderFns } from "./UserPersonaSlot.vue?vue&type=template&id=f4119f02&"
import script from "./UserPersonaSlot.vue?vue&type=script&lang=js&"
export * from "./UserPersonaSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports